import React from "react";
import classNames from "classnames";
import styles from "./KeyValueList.scss";

import { Item } from "./Item";

export const KeyValueList = ({ horizontal, compact, wrap, align, reverse, children }) => {
    const items = React.Children.toArray(children)?.filter((child) => child.type === Item);
    return items?.length ? (
        <table
            className={classNames(styles.base, {
                [styles.horizontal]: horizontal,
                [styles.wrap]: wrap,
                [styles.compact]: compact,
                [styles.alignRight]: align === "right"
            })}
        >
            {!horizontal ? (
                <tbody>
                    {items.map(({ props }, index) => (
                        <tr key={index}>
                            {compact ? (
                                <td>
                                    <div className={styles.label}>{props.label}</div>
                                    <div className={styles.value}>{props.children}</div>
                                </td>
                            ) : (
                                <>
                                    <td className={styles.label}>{props.label}</td>
                                    <td className={styles.value}>{props.children}</td>
                                </>
                            )}
                        </tr>
                    ))}
                </tbody>
            ) : (
                <tbody>
                    <tr>
                        {items.map(({ props }, index) => (
                            <td key={index}>
                                {reverse ? (
                                    <>
                                        <div className={styles.value}>{props.children}</div>
                                        <div className={styles.label}>{props.label}</div>
                                    </>
                                ) : (
                                    <>
                                        <div className={styles.label}>{props.label}</div>
                                        <div className={styles.value}>{props.children}</div>
                                    </>
                                )}
                            </td>
                        ))}
                    </tr>
                </tbody>
            )}
        </table>
    ) : null;
};
